import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { AddLayerBusinessIdentifierComponent } from '@connect-services/client/components/add-layer-business-identifier/add-layer-business-identifier.component';
import { FieldInterventionContextIconComponent } from '@connect-services/client/components/field-intervention-context-icon/field-intervention-context-icon.component';
import {
    AddLayerSelectionType,
    AddLayerService,
    FieldInterventionContextConfig,
} from '@connect-services/client/services/add-layer.service';
import { CreateLayerDtoWithoutProject } from '@connect-services/client/services/layer-creation-form.service';
import { InputTextComponent } from '@connect-services/src/lib/components/input/text/input-text/input-text.component';
import { CustomColumn, CustomTableComponent } from '@connect-services/src/lib/components/table/table.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AddLayerBusinessIdentifierComponent,
        CustomTableComponent,
        FieldInterventionContextIconComponent,
        InputTextComponent,
        RessourcesModule,
    ],
    selector: 'app-table-layer-list-info',
    standalone: true,
    templateUrl: './table-layer-list-info.component.html',
})
export class TableLayerListInfoComponent {
    public readonly canManageFieldInterventionContextSelection = computed(() => {
        if (!this.hasGeomProperty() || this.layerType() !== AddLayerSelectionType.TABLE) {
            return false;
        }

        return this.addLayerService.canManageFieldInterventionContextSelection(this.hasFieldInterventions());
    });
    public readonly columns = input.required<CustomColumn[]>();
    public readonly hasFieldInterventions = input.required<boolean>();
    public readonly hasGeomProperty = input<boolean>(true);
    public readonly isInterstandardFolderSelected = input.required<boolean>();
    public readonly layerInfo = input.required<Record<string, CreateLayerDtoWithoutProject>>();
    public readonly layerType = input.required<AddLayerSelectionType>();
    public readonly shouldDisplayFieldInterventionContextColumn = computed(() => {
        if (!this.hasGeomProperty() || this.layerType() !== AddLayerSelectionType.TABLE) {
            return false;
        }

        return this.addLayerService.canShowFieldInterventionColumn(this.hasFieldInterventions());
    });
    public readonly title = input.required<string>();

    protected readonly AddLayerSelectionType = AddLayerSelectionType;
    protected readonly addLayerService = inject(AddLayerService);
    protected readonly Object = Object;

    protected getFieldInterventionContextConfig(uniqueId: string): FieldInterventionContextConfig | null {
        return this.addLayerService.fieldInterventionContextByLayerId()[uniqueId] ?? null;
    }
}
